import clsx from 'clsx';
import React from 'react';

interface NewsletterDetailsProps {
  author: string;
  description: string;
  frequency: string;
  name: string;
}

const MAX_SINGLE_TITLE_LENGTH = 22;

const NewsletterDetails = ({ author, description, frequency, name }: NewsletterDetailsProps) => {
  return (
    <div className="h-[250px] overflow-hidden pb-24">
      <div className="pt-2 font-suisse-intl-mono text-overline-md text-primary-magenta">
        {frequency}
      </div>
      <h3 className="m-0 pt-4 font-suisse-neue text-subheadline-sm">{name}</h3>
      <div className="pt-4 font-suisse-screen text-byline-sm">By {author}</div>
      <div
        className={clsx('pt-12 font-suisse-intl text-button-md', {
          'line-clamp-4': name.length > MAX_SINGLE_TITLE_LENGTH,
          'line-clamp-5': name.length <= MAX_SINGLE_TITLE_LENGTH,
        })}
      >
        {description}
      </div>
    </div>
  );
};

export default NewsletterDetails;
